// src/App.js
import React, { useEffect } from "react";
import { HashRouter as Router, useLocation } from "react-router-dom";
import Footer from "./components/Layout/Footer";
import "./App.css";
import AppRoutes from "./AppRoutes";
import { LanguageProvider } from "./context/LanguageContext";

// Unified analytics tracker
function useAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    // Google Analytics tracking
    if (window.gtag) {
      window.gtag("config", "G-D5HTK4GS3X", { page_path: pagePath });
      console.log("GA tracked page:", pagePath);
    }

    // Custom tracking logic (e.g., Mixpanel, custom API)
    console.log("Custom tracker page:", pagePath);
    // Example: send to custom API
    // fetch("/api/trackPage", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ path: pagePath }),
    // });

  }, [location]);
}

function AppContent() {
  useAnalyticsTracker(); // Single hook for all tracking

  return (
    <>
      <main>
        <AppRoutes />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;